import { Star } from "lucide-react";
import { REVIEWS } from "@/lib/site";
import { useInnhold } from "@/lib/innhold";

export function ReviewsCarousel() {
  // Tekstene eieren kan redigere fra Ascendly-appen. Se src/lib/innhold.ts.
  const t = useInnhold();
  const loop = [...REVIEWS, ...REVIEWS];
  return (
    <div
      className="group relative overflow-hidden [--pause:running] hover:[--pause:paused]"
      onTouchStart={(e) => e.currentTarget.style.setProperty("--pause", "paused")}
      onTouchEnd={(e) => e.currentTarget.style.setProperty("--pause", "running")}
    >
      <div
        className="flex gap-6 w-max animate-marquee"
        style={{ animationPlayState: "var(--pause)" as never }}
      >
        {loop.map((r, i) => (
          <figure
            key={i}
            className="w-[320px] sm:w-[380px] shrink-0 rounded-2xl border border-border bg-card p-6 shadow-soft"
          >
            <div className="flex gap-0.5 text-primary">
              {Array.from({ length: 5 }).map((_, s) => (
                <Star key={s} className="h-4 w-4 fill-current" />
              ))}
            </div>
            <blockquote className="mt-4 font-serif text-lg leading-snug text-foreground text-balance">
              “{r.text}”
            </blockquote>
            <figcaption className="mt-5 flex items-center justify-between text-xs">
              <span className="text-foreground/85 font-medium">{r.name}</span>
              <span className="text-muted-foreground">{t("forside.anmeldelser.merke")}</span>
            </figcaption>
          </figure>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-background to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-background to-transparent" />
    </div>
  );
}